import React, { useContext, useState } from "react";

import SelectControl from "../SelecControl/SelectControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import './ChecklistsSubtabla.css';
import checklistContext from "../../context/checklistContext/checklistContext";
import { createEstructuraChecklistsByProcedimiento } from "../../utils/estructuras";


const ChecklistsSubtabla = ({checklists, handleChangeChecklists = () => console.log("Change") ,handleDeleteChecklist = () => console.log("Delete"), componentePadre = 'ProcedimientoForm', tablaSeleccionada, modo}) => {

    const cContext = useContext(checklistContext);
    const {checklistList} = cContext;
    
    const optionsChecklists = (checklistList != undefined) ? checklistList.map(c => ({label:c.name,value:c.codigo,id:c._id})) : []; 

    return <div className={`${tablaSeleccionada != 'checklists' && 'inactive'} categoriasDiv`}>
        <div className={`${componentePadre == 'FormReq' && 'formReqParent'} headerSubtablaChecklists`}>
            {componentePadre == 'ProcedimientoForm' && <label></label>}
            {componentePadre == 'FormReq' && <label>Codigo</label>}
            <label>Nombre</label>
            {componentePadre == 'ProcedimientoForm' && <label>Texto Adicional</label>}
            {componentePadre == 'FormReq' && <label>Num. Checklist</label>}
        </div>
        <div className="bodyTableChecklists">
            {checklists.map((c, i) => <div className={`${componentePadre == 'FormReq' && 'formReqParent'} rrCategoriasAsociadas`} key={i}>
                {componentePadre == 'ProcedimientoForm' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteChecklist(c,i)} />}
                {componentePadre == 'FormReq' && <input disabled='true' value={c.checklist.value}/>}
                <SelectControl placeholder={"Seleccione una tarea..."} modo={componentePadre == 'ProcedimientoForm' ? "Nuevo" : 'Vista'} handleChengeSelect={handleChangeChecklists} optionsSelect={optionsChecklists} valueSeleccionada={c.checklist} tipo={'categoriaRRHH'} propToChange="checklist"  selectSelect={handleChangeChecklists} index={i}/>
                {componentePadre == 'ProcedimientoForm' && <input value={c.textAdic} disabled={componentePadre == 'FormReq'} onChange={(e) => handleChangeChecklists({},i,'textAdic',e.target.value)}/>}
                {componentePadre == 'FormReq' && <input value={c.nroChecklist && c.nroChecklist > 0 ? c.nroChecklist : ''} disabled='true'/>}
            </div>)}
        </div>
    </div>

}

export default ChecklistsSubtabla;